import { Component } from '@angular/core';
import { application } from '../../../core/constants/constants';

@Component({
  standalone: false,
  selector: 'app-reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrl: './reports-menu.component.less',
})
export class ReportsMenuComponent {
  application = application;
}
